












































import { Component, Prop, Vue } from 'vue-property-decorator'
import { IInspType } from '@/api/types'
import { IVendor, IVendorCoverageSet, IVendorCoverage } from '@/api/types-vendor'
import { IRadiusForm } from '@/api/types-fip'
import { getInspTypes } from '@/api/orderTypes'
import { getVendorCoverageSets, deleteVendorCoverage, deleteVendorCoverageList, saveAllVendorCoverage } from '@/api/vendors'
import { VendorCoverageSetsModule } from '@/store/modules/vendorCoverageSets'
import { InspTypeModule } from '@/store/modules/inspTypes'

import InspectionTypesTable from './InspectionTypesTable.vue'
import VendorCoveragesTable from './VendorCoveragesTable.vue'
import EditCoverageDialog from './EditCoverageDialog.vue'
import EditRadiusDialog from './EditRadiusDialog.vue'

@Component({
  name: 'VendorCoveragePage',
  components: {
    InspectionTypesTable,
    VendorCoveragesTable,
    EditCoverageDialog,
    EditRadiusDialog
  }
})
export default class extends Vue {
  @Prop({ default: false }) isEdit!: boolean;
  @Prop({ type: Object }) value!: IVendor;
  // INSPECTION TYPE LIST
  displayDiv = false
  inspTypeList: IInspType[] = []
  inspTypeListLoading = true
  inspTypeListTitle = 'Loading...'
  // COVERAGE SET LIST
  selectedId = 0
  coverageSetList: IVendorCoverageSet[] = []
  // COVERAGE AREA LIST
  coverageTotal = 0
  coverageList: IVendorCoverage[] = []
  coverageListLoading = true
  coverageListTitle = 'Loading...'
  editCoverageDialogVisible = false
  selectedRadius = 10
  editRadiusDialogVisible = false

  async mounted() {
    await this.getList()
    await this.initInspTypes()
    this.$nextTick(() => {
      if (this.coverageSetList.length > 0) {
        this.handleSelect(this.coverageSetList[0].vendorCoverageSetId)
      }
    })
  }

  async getList() {
    const vendorId = this.value.vendorId
    let list = this.coverageSetList
    if (VendorCoverageSetsModule.VendorCoverageSetVendorId !== vendorId) {
      VendorCoverageSetsModule.clearList(vendorId)
      list = []
    }
    if (list.length === 0) {
      const response = await getVendorCoverageSets(vendorId)
      list = response.data
      VendorCoverageSetsModule.loadList(vendorId, list)
    }
    this.coverageSetList = list
  }

  async initInspTypes() {
    let list2 = InspTypeModule.cachedInspTypes
    if (list2.length === 0) {
      console.info(`Fetching inspection types. ${list2.length}`)
      const response = await getInspTypes()
      InspTypeModule.loadInspTypes(response.data)
      list2 = InspTypeModule.cachedInspTypes
    }
    this.inspTypeList = list2
    this.inspTypeListLoading = false
    this.inspTypeListTitle = this.getTitle('InspType')
  }

  async refreshSet() {
    const vendorId = this.value.vendorId
    const { data } = await getVendorCoverageSets(vendorId)
    this.coverageSetList = data
    VendorCoverageSetsModule.loadList(vendorId, data)
    const tempId = this.selectedId
    this.selectedId = 0
    this.handleSelect(tempId)
  }

  async saveAll() {
    console.log(`save All ${this.coverageList.length}`)
    this.coverageListTitle = 'Updating Coverage, please wait...'
    this.coverageListLoading = true
    await saveAllVendorCoverage(this.value.vendorId, this.selectedId, this.coverageList)
    await this.refreshSet()
  }

  async handleSelect(vendorCoverageSetId: number) {
    if (vendorCoverageSetId === this.selectedId) {
      this.selectedId = 0
      return
    }
    const found = this.coverageSetList.find(item => item.vendorCoverageSetId === vendorCoverageSetId)
    if (found === undefined) {
      this.selectedId = 0
      this.setCoverages([])
    } else {
      this.selectedId = vendorCoverageSetId
      this.setCoverages(found.vendorCoverages || [])
    }
  }

  handleAddCoverage() {
    this.editCoverage = this.addNewCoverage()
    this.editCoverageDialogVisible = true
  }

  handleRadius() {
    this.editRadius = this.newRadiusForm()
    this.editRadiusDialogVisible = true
  }

  handleCoverageDialogClose() {
    this.editCoverageDialogVisible = false
    this.refreshSet()
  }

  handleRadiusDialogClose() {
    this.editRadiusDialogVisible = false
    this.selectedRadius = this.editRadius.radius
    this.refreshSet()
  }

  setCoverages(list: IVendorCoverage[]) {
    this.coverageList = list || []
    this.coverageTotal = list.length
    this.coverageListLoading = false
    this.coverageListTitle = this.getTitle('Coverage')
  }

  async handleCoverageDelete(row: IVendorCoverage) {
    this.inspTypeListTitle = 'Deactivating, please wait...'
    await deleteVendorCoverage(this.value.vendorId, row.vendorCoverageSetId, row.vendorCoverageId)
    this.refreshSet()
  }

  async handleCoverageDeleteMultiple(ids: number[]) {
    this.inspTypeListTitle = 'Deactivating, please wait...'
    await deleteVendorCoverageList(this.value.vendorId, this.selectedId, ids)
    this.refreshSet()
  }

  async toggleDisplay() {
    this.displayDiv = !this.displayDiv
  }

  getTitle(type: string) :string {
    switch (type) {
      case 'InspType': return 'Inspection Types'
      case 'Coverage': return 'Vendor Coverage Areas'
      case 'Set': return 'Vendor Coverage Sets'
    }
    return ''
  }

  editRadius: IRadiusForm = {
    vendorId: 0,
    vendorCoverageSetId: 0,
    radius: this.selectedRadius,
    selectedZips: []
  }

  editCoverage: IVendorCoverage = {
    vendorCoverageId: 0, // this.value.vendorCoverageId,
    vendorCoverageSetId: this.selectedId,
    allCounty: false,
    stateFips: '0',
    state: '',
    countyFips: '0',
    county: '',
    city: '',
    postalCode: '',
    lenderRestriction: '',
    inspType1: true,
    inspType2: true,
    inspType3: true,
    inspType4: true,
    inspType5: true,
    distance: 0,
    zipList: []
  }

  addNewCoverage(): IVendorCoverage {
    return {
      vendorCoverageId: 0,
      vendorCoverageSetId: this.selectedId,
      allCounty: false,
      stateFips: '0',
      state: '',
      countyFips: '0',
      county: '',
      city: '',
      postalCode: '',
      lenderRestriction: '',
      inspType1: true,
      inspType2: true,
      inspType3: true,
      inspType4: true,
      inspType5: true,
      distance: 0,
      zipList: []
    }
  }

  newRadiusForm(): IRadiusForm {
    return {
      vendorId: this.value.vendorId,
      vendorCoverageSetId: this.selectedId,
      radius: this.selectedRadius,
      selectedZips: []
    }
  }
}
